<div class="overflow-x-auto">
  <table>
    <thead>
      <tr>
        <th></th>
        <ng-container *ngFor="let type of submissionPermissionTypes; trackBy: trackById">
          <th>
            <div class="d-flex flex-column gap-3 align-items-start justify-content-end">
              <div class="d-flex gap-1 align-items-center">
                <div class="permission-label header-label" i18n>{{ type.name }}</div>
                <button
                  *ngIf="type.id | submissionPermissionTooltip : audience as tooltip"
                  type="button"
                  class="no-style-button tooltip-button"
                  [ngbTooltip]="tooltip"
                  [attr.aria-label]="tooltip"
                  placement="top">
                  <img src="assets/icons/dark/Circle Info.svg" alt="" />
                </button>
              </div>
              <app-indeterminate-checkbox
                [state]="selectAllOfTypeState(type.id)"
                [disabled]="formArray.disabled"
                size="lg"
                (checkboxClicked)="onSelectAllOfTypeClicked(type.id)" />
            </div>
          </th>
        </ng-container>
      </tr>
    </thead>
    <tbody>
      <ng-container *ngFor="let type of formArray.controls">
        <tr>
          <td>
            <div class="permission-label">{{ type.controls.name.value }}</div>
          </td>
          <ng-container *ngFor="let permission of type.controls.submissionPermissions.controls">
            <td>
              <div class="d-flex flex-column align-items-start">
                <app-checkbox-input
                  *ngIf="!(permanentlyDisabledIds | includes : permission.controls.id.value)"
                  [formControl]="permission.controls.hasPermission"
                  [size]="'lg'"
                  (checkboxClicked)="onPermissionChange(permission, type)" />
              </div>
            </td>
          </ng-container>
        </tr>
      </ng-container>
    </tbody>
  </table>
</div>
